import { getStoredActiveOrganization } from './Api';

export const getWebSocketUrl = () => {
	const apiUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/';
	const url = new URL(apiUrl);
	const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
	return `${protocol}//${url.host}/ws/org/`;
};

export const buildWebSocketQuery = (accessToken) => {
	const params = new URLSearchParams({ token: accessToken });
	const activeOrg = getStoredActiveOrganization();
	if (activeOrg?.id) {
		params.set('organization_id', activeOrg.id);
	}
	return params.toString();
};

export const REALTIME_EVENT_LABELS = {
	customer_accepted: 'Customer accepted the bid',
	customer_declined: 'Customer declined the bid',
	payment_received: 'Invoice payment received',
	deposit_received: 'Deposit payment received',
	invoice_sent: 'Invoice sent to customer',
	invoice_resent: 'Invoice resent to customer',
	invoice_voided: 'Invoice voided',
	refund_issued: 'Refund issued',
	sent: 'Email sent to customer',
	opened: 'Customer opened the email',
};
